"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.route = function (name, args) {
    if (args === void 0) { args = {}; }
    return window.route(name, args).toString();
};
exports.currentRouteIs = function (names) {
    var nameList = Array.isArray(names) ? names : [names];
    var current = window.route().current();
    return nameList.indexOf(current) > -1;
};
exports.lastRouteParamIs = function (names) {
    var nameList = Array.isArray(names) ? names : [names];
    var current = window.route().current().split('.').pop();
    return nameList.indexOf(current) > -1;
};
//# sourceMappingURL=route.js.map